import axios from "axios";

//IMPORT API ROUTE URL
import { REMOVE_LANGUAGE_ROUTE } from "./apiRoutes";

const removeLanguageToUser = (resource_slug, language_id) => {
  var postData = new FormData();

  postData.append("language_id", language_id);
  postData.append("resource_slug", resource_slug);

  return axios
    .post(REMOVE_LANGUAGE_ROUTE, postData, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default removeLanguageToUser;
